export class LocationById{
    locationId:number;

    constructor(
        locationId: number,
    ) {
        this.locationId = locationId;
    }
}